import React from "react";
import {
	Box, Grid, Typography
} from "@mui/material";
import {
	makeStyles
} from "@mui/styles";
import agent from "../../../../../agent/agent";
import {VisibleContent} from "../../../../../components";

const VehicleInspection = ({application}) => {
	const classes = useStyles();
	const [information, setInformation] = React.useState([]);
	const getInformation = async () => {
		const res = await agent.get(`/orders/vehicle-inspection?tricepsOrderId=${ application.tricepsOrderId }`)
			.then((res) => res?.data?.data?.[0])
			.catch(() => null);
		setInformation(res);
	};
	React.useEffect(() => {
		(async () => {
			await getInformation();
		})();
	}, [])

	if (!information) {
		return null
	}
	return (
		<Box className={classes.root}>
			<Box mb={1}>
				<Typography variant="h3" textAlign="left">Приемка авто</Typography>
			</Box>

			<Grid container spacing={2}>
				<VisibleContent visible={Boolean(information?.message)}>
					<Grid item xs={12}>
						<div className={classes.sectionTitle}>Сообщения</div>
						<div dangerouslySetInnerHTML={{__html: information?.message}} className={classes.sectionMessage}/>
					</Grid>
				</VisibleContent>
				<VisibleContent visible={(information?.files || []).length > 0}>
					<Grid item xs={12}>
						<div className={classes.sectionTitle}>Фото/видео фиксация</div>
						<div className={classes.sectionImages}>
							<Grid container spacing={2}>
								{(information?.files || []).map((file) => (
									<Grid item xs={2}>
										<a
											target="_blank"
											href={file.url}
											className={classes.sectionIframe}
										><img src={file.url}/></a>
									</Grid>
								))}
							</Grid>
						</div>
					</Grid>
				</VisibleContent>
			</Grid>
		</Box>
	)
}

const useStyles = makeStyles(() => ({
	root: {
		"& b": {
			fontWeight: "500",
			textDecoration: "underline"
		}
	},

	sectionTitle: {
		marginBottom: 4,
		fontSize: 16,
		color: "black",
		lineHeight: 1.2,
		fontWeight: "600"
	},
	sectionIframe: {
		width: "100%",
		display: "flex",
		borderRadius: 10,
		cursor: "pointer",
		overflow: "hidden",
		position: "relative",
		background: "rgba(0,0,0,0.02)",
		border: "1px solid rgba(0,0,0,0.1)",

		"& img": {
			top: 0, left: 0,
			position: "absolute",
			objectFit: "contain",
			width: "100%", height: "100%"
		},
		"&:after": {
			content: "''",
			float: "left",
			paddingTop: "75%",
		}
	},
	sectionImages: {},
	sectionMessage: {
		fontSize: 14,
		opacity: 0.8,
		color: "black",
		lineHeight: 1.2,
		fontWeight: "500"
	},
}));

export default VehicleInspection
